import { Component } from '@angular/core';

@Component({
  selector: 'app-greenscore-modal-en',
  templateUrl: './greenscore-modal-en.component.html',
  styleUrls: ['./greenscore-modal-en.component.scss'],
  standalone: false,
})
export class GreenscoreModalEnComponent {
  constructor() {}
}
